import { CircleCheckIcon } from "@/components/Icons/circle-check-icon";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useAuthStore } from "@/store/auth.store";
import { useNavigate } from "react-router-dom";

type EntryConfirmationModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const EntryConfirmationModal = ({ open, setOpen }: EntryConfirmationModalProps) => {
  const navigate = useNavigate();
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[357x] ring-0 ring-transparent">
        <DialogTitle className="text-black text-center font-Inter text-[20px] font-semibold leading-[30px] mx-auto">
          エントリーが完了しました！
        </DialogTitle>

        <div className="flex justify-center items-center">
          <CircleCheckIcon className="h-[58px] w-[58px] text-secondary" />
        </div>

        <div className="flex flex-col w-full items-center justify-center mt-4">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={() => {
              fetchUser();
              navigate("/prediction-market");
            }}
          >
            エントリーを追加する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
